import { useNavigate } from "react-router";
import { DISCOVER_PRODUCT_SPOTLIGHT } from "../../../constants/routes";
import { useMarketSpotlightPageLayout } from "../../../hooks/api/v2/marketSpotlightLayout/useMarketSpotlightPageLayout";
import { SpotlightListCollection } from "./SpotlightListCollection";

export const SpotlightListCollectionProducts = () => {
  const navigate = useNavigate();
  const marketSpotlightPageLayoutQuery = useMarketSpotlightPageLayout({
    type: "product",
  });

  const pageIds = marketSpotlightPageLayoutQuery.data?.pageIds;

  if (!pageIds?.length) return null;
  return (
    <SpotlightListCollection
      title={"Product spotlights"}
      pageIds={pageIds}
      type={"product style"}
      onClick={() => navigate(DISCOVER_PRODUCT_SPOTLIGHT)}
    />
  );
};
